<template>
<div class='error'>
    404
  </div>
</template>
<script setup>
</script>
<style lang='scss'></style>